export const pathWithState = (to: string, from: string) => ({
  pathname: to,
  state: { from }
});
